import { defineMessages } from "../core"

export const common = defineMessages({
  en: {},
  de: {},
})
